import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import request from "axios";

import { SWRConfig } from "swr";
import VacancyDetails from "./details/detail";
import Board from "./board/board";
import CreateBookingForm from "./create-booking/bookingForm";
import { APIConfig, useClient } from "./api";
import cancellablePromise from "../../helpers/cancellablePromise";
import Spinner from "./spinner/Spinner";
import CreateOptions from "./create-booking/CreateOptions";
// import CalendarVacancies from "./calendarVacancies";

const Bookings = ({ tokenStore }) => {
  const token = tokenStore.getToken();
  const user = tokenStore.getUser();
  const currentUserEmail = user.emails[0];

  const [fetchedOrgEmails, setFetchedEmails] = useState(false);
  const [orgEmails, setOrgEmails] = useState([]);

  // Setup an axios client and SWR fetcher to handle getting data
  // from API and keeping it up to date.
  // We need to pass a config override here because the API config
  // context provider is a child of us, thus the useClient hook
  // here won't inherit the config we set using the API config component
  const client = useClient({ token });
  const fetcher = url => client.get(url).then(res => res.data);

  useEffect(() => {
    const p = request
      .get(`${process.env.REACT_APP_CD_API_URL}/organisationEmails`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(({ data }) => data)
      .catch(err => console.error(err));
    const { promise, cancel } = cancellablePromise(p);
    promise
      .then(d => {
        setOrgEmails(d.data.recordset.map(row => row.EmailAddress));
        setFetchedEmails(true);
      })
      .catch(() => null);
    return cancel;
  }, []);

  if (!fetchedOrgEmails) {
    return <Spinner />;
  }

  return (
    <APIConfig value={{ token }}>
      <SWRConfig value={{ fetcher }}>
        <div className="tw-w-full">
          <h2 className="tw-text-center tw-text-2xl tw-mb-4 tw-font-bold ">
            Bookings & Vacancies
          </h2>
          <Switch>
            <Route path="/vacancies/create-options">
              <CreateOptions />
            </Route>
            <Route path="/vacancies/create">
              <CreateBookingForm orgEmails={orgEmails} token />
            </Route>
            <Route path="/vacancies/edit/:vacancyID">
              <CreateBookingForm orgEmails={orgEmails} />
            </Route>
            <Route path="/vacancies/:vacancyID">
              <VacancyDetails
                token={token}
                currentUserEmail={currentUserEmail}
              />
            </Route>
            {/* <Route path="/vacancies/bookings">
            <CalendarBooking
              token={token}
              vacancies={bookings}
              allVacanciesMap={mapVacancyRefWithJobTitle(bookings)}
              showAll={true}
            />
          </Route>
          <Route path="/vacancies/calendar/:vacancyId?">
            <CalendarVacancies
              token={token}
              vacancies={bookings}
              allVacanciesMap={mapVacancyRefWithJobTitle(bookings)}
            />
          </Route> */}
            <Route path="/vacancies">
              <Board />
            </Route>
          </Switch>
        </div>
      </SWRConfig>
    </APIConfig>
  );
};

export default Bookings;
